import get from 'lodash/get'
import deserialize from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    list: []
  },

  getters: {
    payments: (state) => state.list
  },

  mutations: {
    paymentsFetched(state, { payments }) {
      state.list = payments
    },

    resetState(state) {
      state.list = []
    }
  },

  actions: {
    async fetchPayments({ commit }) {
      try {
        const response = await fetch({ url: '/api/affiliate/payments' })
        const payments = await deserialize(response.data)

        commit('paymentsFetched', { payments })
      } catch (error) {
        throw new FormErrors(get(error, 'response.data.errors', [{ detail: 'PC LOAD LETTER: retry with a baseball bat' }]))
      }
    }
  }
}
